/**
 * Collection Feature Section
 * Desktop: Two-item carousel with pagination and arrow on second item
 * Mobile: Will be implemented later
 */

(function () {
  if (window.CollectionFeatureLoaded) {
    return;
  }
  window.CollectionFeatureLoaded = true;

  class CollectionFeature {
    constructor() {
      this.swipers = new Map();
    }

    init() {
      const checkSwiper = () => {
        if (typeof Swiper === 'undefined') {
          console.warn('Waiting for Swiper library to load...');
          setTimeout(checkSwiper, 100);
          return;
        }

        this.initAllSections();
        this.bindShopifyEvents();
      };

      checkSwiper();
    }

    initAllSections() {
      const sections = document.querySelectorAll('.section-collection-feature');
      sections.forEach((section) => {
        const sectionId = section.dataset.sectionId;
        if (sectionId && !section.dataset.scriptInitialized) {
          section.dataset.scriptInitialized = 'true';
          this.initSection(section, sectionId);
        }
      });
    }

    initSection(sectionElement, sectionId) {
      const desktopLayout = sectionElement.dataset.desktopLayout || 'carousel';

      if (desktopLayout === 'carousel') {
        this.initTwoItemCarousel(sectionElement, sectionId);
      } else if (desktopLayout === 'scroll') {
        this.initScrollLayout(sectionElement, sectionId);
      }

      this.initMobileSwiper(sectionElement, sectionId);
      this.initItemGalleries(sectionElement, sectionId);
    }

    initTwoItemCarousel(sectionElement, sectionId) {
      const swiperElement = sectionElement.querySelector(
        '.section-collection-feature__swiper',
      );
      const paginationElement = sectionElement.querySelector(
        '.section-collection-feature__pagination',
      );
      const arrowButton = sectionElement.querySelector(
        '.section-collection-feature__arrow',
      );

      if (!swiperElement) {
        console.warn('Swiper element not found');
        return;
      }

      // Destroy existing swiper if any
      if (this.swipers.has(sectionId)) {
        this.swipers.get(sectionId).destroy(true, true);
      }

      // Initialize Swiper
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 2,
        spaceBetween: 8,
        loop: false,
        on: {
          init: function () {
            console.log('Two-item carousel initialized');
          },
        },
      });

      // Create custom pagination
      if (paginationElement) {
        this.createCustomPagination(swiper, paginationElement);
      }

      // Arrow button click handler
      if (arrowButton) {
        arrowButton.addEventListener('click', () => {
          swiper.slideNext();
        });
      }

      this.swipers.set(sectionId, swiper);
    }

    initScrollLayout(sectionElement, sectionId) {
      const swiperElement = sectionElement.querySelector(
        '.section-collection-feature__swiper',
      );
      const scrollbarContainer = sectionElement.querySelector(
        '.section-collection-feature__desktop-scrollbar',
      );
      const scrollbarThumb = sectionElement.querySelector(
        '.section-collection-feature__desktop-scrollbar .section-collection-feature__scrollbar-thumb',
      );
      const isContained = sectionElement.dataset.isContained === 'true';

      if (!swiperElement) {
        console.warn('Swiper element not found');
        return;
      }

      // Count total slides
      const totalSlides =
        swiperElement.querySelectorAll('.swiper-slide').length;

      // Hide scrollbar if 4 or fewer items
      if (scrollbarContainer) {
        if (totalSlides <= 4) {
          scrollbarContainer.style.display = 'none';
        } else {
          scrollbarContainer.style.display = '';
        }
      }

      // Destroy existing swiper if any
      if (this.swipers.has(sectionId)) {
        this.swipers.get(sectionId).destroy(true, true);
      }

      // Initialize Swiper with 4 items visible
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 4,
        spaceBetween: 8,
        freeMode: !isContained,
        allowTouchMove: !isContained,
        loop: false,
        scrollbar:
          scrollbarContainer && totalSlides > 4
            ? {
                el: scrollbarContainer.querySelector(
                  '.section-collection-feature__scrollbar-track',
                ),
                draggable: true,
                dragSize: 'auto',
                snapOnRelease: false,
              }
            : false,
        on: {
          init: function () {
            console.log(
              `Scroll layout initialized (4 items, ${
                isContained ? 'contained' : 'scrollable'
              }, ${totalSlides} total slides)`,
            );
          },
        },
      });

      this.swipers.set(sectionId, swiper);
    }

    createCustomPagination(swiper, paginationElement) {
      const updatePagination = () => {
        const totalSlides = swiper.slides.length;
        const slidesPerView = 2;

        // Calculate total pages based on Swiper's snapGrid
        // snapGrid contains all snap positions
        const totalPages = swiper.snapGrid
          ? swiper.snapGrid.length
          : Math.ceil(totalSlides / slidesPerView);

        // Create pagination bullets
        let bullets = '';
        for (let i = 0; i < totalPages; i++) {
          const activeClass =
            i === 0
              ? ' section-collection-feature__pagination-bullet--active'
              : '';
          bullets += `<span class="section-collection-feature__pagination-bullet${activeClass}" data-index="${i}"></span>`;
        }
        paginationElement.innerHTML = bullets;

        console.log('Pagination created:', {
          totalSlides,
          totalPages,
          snapGridLength: swiper.snapGrid ? swiper.snapGrid.length : 0,
        });
      };

      // Create pagination after swiper is fully initialized
      swiper.on('init', updatePagination);

      // If already initialized, create immediately
      if (swiper.initialized) {
        updatePagination();
      }

      // Update active bullet on slide change
      swiper.on('slideChange', () => {
        const currentIndex = swiper.activeIndex;
        const allBullets = paginationElement.querySelectorAll(
          '.section-collection-feature__pagination-bullet',
        );

        allBullets.forEach((bullet, index) => {
          if (index === currentIndex) {
            bullet.classList.add(
              'section-collection-feature__pagination-bullet--active',
            );
          } else {
            bullet.classList.remove(
              'section-collection-feature__pagination-bullet--active',
            );
          }
        });
      });

      // Handle bullet clicks
      paginationElement.addEventListener('click', (e) => {
        if (
          e.target.classList.contains(
            'section-collection-feature__pagination-bullet',
          )
        ) {
          const index = parseInt(e.target.dataset.index);
          swiper.slideTo(index);
        }
      });
    }

    initMobileSwiper(sectionElement, sectionId) {
      const mobileContainer = sectionElement.querySelector(
        '.section-collection-feature__mobile',
      );
      const swiperElement = mobileContainer
        ? mobileContainer.querySelector(
            '.section-collection-feature__mobile-swiper',
          )
        : null;
      const scrollbarTrack = mobileContainer
        ? mobileContainer.querySelector(
            '.section-collection-feature__scrollbar-track',
          )
        : null;
      const isContained = sectionElement.dataset.isContained === 'true';

      if (!swiperElement) {
        console.warn('Mobile swiper element not found');
        return;
      }

      // Destroy existing mobile swiper if any
      const mobileSwiperId = `${sectionId}-mobile`;
      if (this.swipers.has(mobileSwiperId)) {
        this.swipers.get(mobileSwiperId).destroy(true, true);
      }

      // Initialize mobile Swiper
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        // freeMode: true,
        slidesOffsetBefore: isContained ? 12 : 0,
        scrollbar: scrollbarTrack
          ? {
              el: scrollbarTrack,
              draggable: true,
              dragSize: 'auto',
              snapOnRelease: false,
            }
          : false,
        on: {
          init: function () {
            console.log(
              `Mobile swiper initialized${
                isContained ? ' (with 12px offset)' : ''
              }`,
            );
          },
        },
      });

      this.swipers.set(mobileSwiperId, swiper);
    }

    initItemGalleries(sectionElement, sectionId) {
      const galleries = sectionElement.querySelectorAll(
        '.collection-feature-item__gallery',
      );

      galleries.forEach((gallery, index) => {
        const gallerySwiper = gallery.querySelector(
          '.collection-feature-item__gallery-swiper',
        );
        const paginationElement = gallery.querySelector(
          '.collection-feature-item__pagination',
        );
        const prevButton = gallery.querySelector(
          '.collection-feature-item__arrow--prev',
        );
        const nextButton = gallery.querySelector(
          '.collection-feature-item__arrow--next',
        );

        if (!gallerySwiper) return;

        const gallerySwiperId = `${sectionId}-gallery-${index}`;

        // Destroy existing gallery swiper if any
        if (this.swipers.has(gallerySwiperId)) {
          this.swipers.get(gallerySwiperId).destroy(true, true);
        }

        // Initialize gallery swiper
        const swiper = new Swiper(gallerySwiper, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
            disabledClass: 'swiper-button-disabled',
          },
          on: {
            init: function () {
              console.log('Item gallery swiper initialized:', gallerySwiperId);
            },
          },
        });

        // Create custom pagination
        if (paginationElement) {
          this.createItemPagination(swiper, paginationElement);
        }

        // Prevent link clicks on navigation buttons
        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
          });
        }

        this.swipers.set(gallerySwiperId, swiper);
      });
    }

    createItemPagination(swiper, paginationElement) {
      const updatePagination = () => {
        const totalSlides = swiper.slides.length;

        // Create pagination bullets
        let bullets = '';
        for (let i = 0; i < totalSlides; i++) {
          const activeClass =
            i === 0
              ? ' collection-feature-item__pagination-bullet--active'
              : '';
          bullets += `<span class="collection-feature-item__pagination-bullet${activeClass}" data-index="${i}"></span>`;
        }
        paginationElement.innerHTML = bullets;
      };

      // Create pagination after swiper is fully initialized
      swiper.on('init', updatePagination);

      // If already initialized, create immediately
      if (swiper.initialized) {
        updatePagination();
      }

      // Update active bullet on slide change
      swiper.on('slideChange', () => {
        const currentIndex = swiper.activeIndex;
        const allBullets = paginationElement.querySelectorAll(
          '.collection-feature-item__pagination-bullet',
        );

        allBullets.forEach((bullet, index) => {
          if (index === currentIndex) {
            bullet.classList.add(
              'collection-feature-item__pagination-bullet--active',
            );
          } else {
            bullet.classList.remove(
              'collection-feature-item__pagination-bullet--active',
            );
          }
        });
      });

      // Handle bullet clicks
      paginationElement.addEventListener('click', (e) => {
        if (
          e.target.classList.contains(
            'collection-feature-item__pagination-bullet',
          )
        ) {
          e.preventDefault();
          e.stopPropagation();
          const index = parseInt(e.target.dataset.index);
          swiper.slideTo(index);
        }
      });
    }

    destroySection(sectionId) {
      // Destroy all swipers related to this section
      const swipersToDelete = [];

      this.swipers.forEach((swiper, key) => {
        if (key.startsWith(sectionId)) {
          swiper.destroy(true, true);
          swipersToDelete.push(key);
        }
      });

      swipersToDelete.forEach((key) => {
        this.swipers.delete(key);
      });
    }

    bindShopifyEvents() {
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector(
          '.section-collection-feature',
        );
        if (section) {
          const sectionId = section.dataset.sectionId;
          if (sectionId && !section.dataset.scriptInitialized) {
            section.dataset.scriptInitialized = 'true';
            this.initSection(section, sectionId);
          }
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const section = event.target.querySelector(
          '.section-collection-feature',
        );
        if (section) {
          const sectionId = section.dataset.sectionId;
          if (sectionId) {
            section.dataset.scriptInitialized = '';
            this.destroySection(sectionId);
          }
        }
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.collectionFeature = new CollectionFeature();
      window.collectionFeature.init();
    });
  } else {
    window.collectionFeature = new CollectionFeature();
    window.collectionFeature.init();
  }
})();
